import React, { RefObject } from 'react';

interface OTPInputProps {
  inputRef: RefObject<HTMLInputElement>;
  nextRef: RefObject<HTMLInputElement> | null;
  prevRef: RefObject<HTMLInputElement> | null;
  handleOtpInput: (e: React.ChangeEvent<HTMLInputElement>, nextInputRef: RefObject<HTMLInputElement> | null) => void;
  handleBackspace: (currentRef: RefObject<HTMLInputElement>, prevRef: RefObject<HTMLInputElement> | null) => void;
  handlePaste: (e: React.ClipboardEvent<HTMLInputElement>) => void;
}

const OTPInput: React.FC<OTPInputProps> = ({ inputRef, nextRef, prevRef, handleOtpInput, handleBackspace, handlePaste }) => {
  return (
    <input
      type="number"
      ref={inputRef}
      className="rounded-4 border border-1 otp-input ms-2"
      maxLength={1}
      onInput={(e:React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, nextRef)}
      onPaste={handlePaste}
      onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(inputRef, prevRef)}
    />
  );
};

export default OTPInput;
